import React from "react";

import Card from "../../../../components/card";
import S from "./strings";
import { TabProps } from "./helpers";
import { DeepLink } from "./enrollmentUpdatesController";
import ActualizarTab from "./actualizarTab";
import PorAplicarTab from "./porAplicarTab";
import FlotantesTab from "./flotantesTab";
import HistorialTab from "./historialTab";
// Matrículas' filter bar and tab counter (waFm*, waTabCuenta) live in its own sheet: load it here too.
import "../enrollmentRequests/filtrosMatriculas.css";
import "./styles.css";

export const TABS = ["actualizar", "aplicar", "flotantes", "historial"] as const;
export type TabKey = typeof TABS[number];

interface Props {
	campusName: string;
	movil: boolean;
	tab: TabKey;
	onTab: (t: TabKey) => void;
	onGoTo: (t: TabKey) => void;
	counts: { pending: number; returned: number; floating: number };
	notice: { text: string; ok: boolean } | null;
	onCloseNotice: () => void;
	tabProps: TabProps;
	link: DeepLink;
}

/*
	Same shell as Matrículas (2026-11-01): waModulo + <h4>, the notice as a Bootstrap alert above the card,
	and the tabs as nav-pills waTabs with their counter (waTabCuenta) inside one Card.
	The campus already shows in the top bar, so it is no longer repeated here.
*/
const EnrollmentUpdatesView: React.FC<Props> = ({ movil, tab, onTab, counts, notice, onCloseNotice, tabProps, link }) => {
	const tabs: { key: TabKey; label: string; count?: number; oro?: boolean }[] = [
		{ key: "actualizar", label: S.tabs.actualizar },
		{ key: "aplicar", label: S.tabs.aplicar, count: counts.pending + counts.returned },
		{ key: "flotantes", label: S.tabs.flotantes, count: counts.floating, oro: true },
		{ key: "historial", label: S.tabs.historial },
	];
	return (
		<div className={"container-fluid waModulo wau" + (movil ? " movil" : "")}>
			<div className="wau-encabezado">
				<h4 style={{ margin: 0 }}>{S.title}</h4>
			</div>
			{notice ? (
				<div className={"alert " + (notice.ok ? "alert-light border" : "alert-warning") + " wau-alerta"} role="status">
					<span>{notice.text}</span>
					<button type="button" className="btn-close" aria-label={S.close} onClick={onCloseNotice} />
				</div>
			) : ""}
			<Card>
				<div className="wau-cuerpo">
					<ul className="nav nav-pills waTabs wau-pestanas" role="tablist">
						{tabs.map((t) => (
							<li className="nav-item" key={t.key}>
								<button type="button" role="tab" aria-selected={tab === t.key} className={"nav-link btn btn-sm" + (tab === t.key ? " active" : "")} onClick={() => onTab(t.key)}>
									{t.label}{t.count ? <span className={"waTabCuenta" + (t.oro ? " oro" : "")}>{t.count}</span> : null}
								</button>
							</li>
						))}
					</ul>
					{tab === "actualizar" ? <ActualizarTab {...tabProps} link={link} /> : ""}
					{tab === "aplicar" ? <PorAplicarTab {...tabProps} initialId={link.updateId} /> : ""}
					{tab === "flotantes" ? <FlotantesTab {...tabProps} /> : ""}
					{tab === "historial" ? <HistorialTab {...tabProps} /> : ""}
				</div>
			</Card>
		</div>
	);
};

export default EnrollmentUpdatesView;
